import { logger } from '../../../../utils/common/logger'
import { DOMUtils } from '../../../../utils/dom'
import { Store } from '../../../../utils/storage/keys'
import { LocalStore } from '../../../../utils/storage/local'
import { IProfile } from '../../../common/profile'
import { LoginService } from '../loginradius/services/login-service'
import SailthruAdapter from '../sailthru'

export class OnboardFollowAuthor {
    public static DOM = {
        attr : {
            followAuthorCheckbox: 'data-follow-author-checkbox',
            followAuthorForm: 'data-follow-author-form'
        },
        class: {
            followAuthorChecked: 'follow-author__checkbox--checked',
            onboardFollowAuthor: 'page-onboard-follow-author'
        }
    }

    /**
     * Initialize onboarding follow author
     */
    public init() {
        const onboardFollowAuthorPage = document.querySelector(
            `.${OnboardFollowAuthor.DOM.class.onboardFollowAuthor}`)

        if (onboardFollowAuthorPage) {
            const followAuthorCheckboxes = document.querySelectorAll(
                `[${OnboardFollowAuthor.DOM.attr.followAuthorCheckbox}]`)
            const followAuthorForm = document.querySelector(
                `[${OnboardFollowAuthor.DOM.attr.followAuthorForm}]`) as HTMLButtonElement
            const profile = LocalStore.get<IProfile>(Store.ID)
            const email = (profile && profile.email) ? profile.email : undefined

            // Follow author checkboxes
            if (followAuthorCheckboxes) {
                followAuthorCheckboxes.forEach((followAuthorCheckbox: HTMLInputElement) => {
                    followAuthorCheckbox.addEventListener('change', (event) => {
                        const target = event.target as HTMLInputElement
                        const checkboxWrapper = target.parentElement

                        if (target.checked) {
                            DOMUtils.addClass(checkboxWrapper, OnboardFollowAuthor.DOM.class.followAuthorChecked)
                        } else {
                            DOMUtils.removeClass(checkboxWrapper, OnboardFollowAuthor.DOM.class.followAuthorChecked)
                        }
                    })
                })
            }

            // Follow author form
            if (followAuthorForm) {
                const sailthruListId = followAuthorForm.getAttribute(
                    OnboardFollowAuthor.DOM.attr.followAuthorForm)

                followAuthorForm.addEventListener('submit', async (event) => {
                    const followAuthorChecklist = document.querySelectorAll(
                        `[${OnboardFollowAuthor.DOM.attr.followAuthorCheckbox}]`)
                    let authorsSelected = {}

                    event.preventDefault()

                    // Get list of authors selected
                    followAuthorChecklist.forEach((followAuthor: HTMLInputElement) => {
                        if (followAuthor.checked) {
                            const authorName = followAuthor.getAttribute(
                                OnboardFollowAuthor.DOM.attr.followAuthorCheckbox)
                            authorsSelected = {...authorsSelected, [authorName]: 'Y'}
                        }
                    })

                    // Redirect to next onboarding step if there are no authors selected
                    if (Object.keys(authorsSelected).length === 0) {
                        logger('info', 'OnboardFollowAuthor.init - No authors selected')
                        this.redirectToNextStep()
                        return
                    }

                    logger('info', 'OnboardFollowAuthor.init - authors selected: ', authorsSelected)

                    // Add email to Sailthru email list
                    try {
                        if (email) {
                            await SailthruAdapter.addToEmailList(email, sailthruListId, authorsSelected)
                            this.redirectToNextStep()
                        } else {
                            logger('error', 'OnboardFollowAuthor.init - User is not logged in')
                            this.redirectToNextStep()
                        }
                    } catch (e) {
                        this.redirectToNextStep()
                    }
                })
            }
        }
    }

    /**
     * Redirect to the next onboarding step
     */
    private redirectToNextStep() {
        setTimeout(() => {
            LoginService.sendFormSubmissionEvent('onboard-follow-author')
        }, 0) // Execute in next event cycle

        logger('info', 'redirecting to newsletter opt in onboarding page')
        location.replace('/onboard-epaper/')
    }
}
